import React, { useState } from "react";

const galleryItems = [
  { type: "image", url: "https://spst.in/images/d-1.jpeg", category: "latest" },
  
    { type: "image", url: "https://spst.in/images/d-3.jpeg", category: "latest" },
     { type: "image", url: "https://spst.in/images/d-4.jpeg", category: "latest" },
     
         { type: "image", url: "https://spst.in/images/d-8.jpeg", category: "latest" },
       
           { type: "image", url: "https://spst.in/images/d-10.jpeg", category: "latest" },
            
             { type: "image", url: "https://spst.in/images/d-12.jpeg", category: "latest" },
             
               { type: "image", url: "https://spst.in/images/d-14.jpeg", category: "latest" },
                { type: "image", url: "https://spst.in/images/d-15.jpeg", category: "latest" },
                 

     { type: "image", url: "https://spst.in/images/d-2.jpeg", category: "latest" },
      { type: "image", url: "https://spst.in/images/d-5.jpeg", category: "latest" },
       { type: "image", url: "https://spst.in/images/d-6.jpeg", category: "latest" },
        { type: "image", url: "https://spst.in/images/d-7.jpeg", category: "latest" },
           { type: "image", url: "https://spst.in/images/d-9.jpeg", category: "latest" },
           { type: "image", url: "https://spst.in/images/d-11.jpeg", category: "latest" },
            { type: "image", url: "https://spst.in/images/d-13.jpeg", category: "latest" },
      { type: "image", url: "https://spst.in/images/d-16.jpeg", category: "latest" },
                  { type: "image", url: "https://spst.in/images/d-17.jpeg", category: "latest" },
                   { type: "image", url: "https://spst.in/images/d-18.jpeg", category: "latest" },
                    { type: "image", url: "https://spst.in/images/d-19.jpeg", category: "latest" },


  
  { type: "video", url: "https://spst.in/images/deepam.mp4", category: "latest" },
];

function Lakshadeepam() {
  const [filter, setFilter] = useState("all");
  const [viewerIndex, setViewerIndex] = useState(null); // fullscreen viewer

  const filteredItems =
    filter === "all"
      ? galleryItems
      : galleryItems.filter((item) => item.category === filter);

  const openViewer = (index) => setViewerIndex(index);
  const closeViewer = () => setViewerIndex(null);

  const showNext = () => {
    setViewerIndex((prev) => (prev + 1) % filteredItems.length);
  };

  const showPrev = () => {
    setViewerIndex((prev) =>
      prev === 0 ? filteredItems.length - 1 : prev - 1
    );
  };

  return (
    <div>
      <div
        className="row banner"
        style={{
          backgroundImage: "url(./images/event.jpeg)",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      ></div>

      <div className="container" style={{ marginTop: "100px", marginBottom: "100px" }}>
        
        <h1 style={{fontSize:'25pt',fontWeight:'700'}}>Lakshadeepm 2019-2020</h1>
        {/* Gallery Grid */}
        <div style={galleryStyle}>
          {filteredItems.map((item, index) => (
            <div key={index} style={itemStyle} onClick={() => openViewer(index)}>
              {item.type === "image" ? (
                <img src={item.url} alt="" style={imgStyle} />
              ) : (
                <video src={item.url} style={imgStyle} />
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Fullscreen Viewer */}
      {viewerIndex !== null && (
        <div style={viewerOverlay}>
          <div style={viewerContent}>
            <span style={closeBtn} onClick={closeViewer}>
              &times;
            </span>

            <span style={navBtnLeft} onClick={showPrev}>
              &#10094;
            </span>
            <span style={navBtnRight} onClick={showNext}>
              &#10095;
            </span>

            {filteredItems[viewerIndex].type === "image" ? (
              <img
                src={filteredItems[viewerIndex].url}
                alt=""
                style={viewerMedia}
              />
            ) : (
              <video
                src={filteredItems[viewerIndex].url}
                controls
                autoPlay
                muted
                style={viewerMedia}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
}

/* ----------------- Styles ----------------- */

const galleryStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
  gap: "15px",
};

const itemStyle = {
  borderRadius: "8px",
  overflow: "hidden",
  cursor: "pointer",
};

const imgStyle = {
  width: "100%",
  objectFit: "cover",
};

const viewerOverlay = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  backgroundColor: "rgba(0,0,0,0.9)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999,
};

const viewerContent = {
  position: "relative",
  maxWidth: "90%",
  maxHeight: "90%",
};

const viewerMedia = {
  maxWidth: "100%",
  maxHeight: "90vh",
  borderRadius: "10px",
};

const closeBtn = {
  position: "absolute",
  top: "-40px",
  right: "0",
  fontSize: "40px",
  color: "white",
  cursor: "pointer",
};

const navBtnLeft = {
  position: "absolute",
  top: "50%",
  left: "-60px",
  fontSize: "50px",
  cursor: "pointer",
  color: "white",
};

const navBtnRight = {
  position: "absolute",
  top: "50%",
  right: "-60px",
  fontSize: "50px",
  cursor: "pointer",
  color: "white",
};

export default Lakshadeepam;
